import React from "react";
import { DatePicker, Col, Form, Row, Select } from "antd";
import locale from "antd/lib/date-picker/locale/ja_JP";
import * as moment from "moment-timezone";
import { observer } from "mobx-react";

import { FInput, FSelect } from "../../common/form";
import ChildrenTemplaceRender from "../ChildrenTemplateRender";
import Book from "../../models/Book";
import { hankaku2Zenkaku } from "../../utils/";

moment.tz.setDefault("Asia/Tokyo");

const Option = Select.Option;

const Input = ({ label, span, ...props }) => (
  <Col span={span}>
    <FInput label={label} {...props} />
  </Col>
);

let isOverOneYear = false; // シカケテガミに刻印する記念日を1年後を選択した時、吹き出しで警告を表示させる

// 文字数制限を超えているか
let isCNameTooLong = false;
const CNameLimit = 10;
let isRNameTooLong = false;
const RNameLimit = 6;
let isCNickNameTooLong = false;
const CNickNameLimit = 6;
let isSNickNameTooLong = false;
const SNickNameLimit = 6;
let isGrandFatherNickNameTooLong = false;
const GrandFatherNickNameLimit = 6;
let isGrandMotherNickNameTooLong = false;
const GrandMotherNickNameLimit = 6;

const childrenAgeList = [
  { value: "", text: "" },
  { value: "0", text: "0歳" },
  { value: "1", text: "1歳" },
  { value: "2", text: "2歳" },
  { value: "3", text: "3歳" },
  { value: "4", text: "4歳" },
  { value: "5", text: "5歳" },
  { value: "6", text: "6歳" },
  { value: "7", text: "7歳" },
  { value: "8", text: "8歳" },
  { value: "9", text: "9歳" },
  { value: "10", text: "10歳" },
  { value: "11", text: "11歳" },
  { value: "12", text: "12歳" },
  { value: "13", text: "13歳" },
  { value: "14", text: "14歳" },
  { value: "15", text: "15歳" },
  { value: "16", text: "16歳" },
  { value: "17", text: "17歳" },
  { value: "18", text: "18歳" },
  { value: "over19", text: "19歳以上" },
];
const childrenAgeSexList = [
  { value: "", text: "" },
  { value: "male", text: "男の子" },
  { value: "female", text: "女の子" },
];
const singleStateList = [
  { value: "0", text: "あり" },
  { value: "1", text: "なし" },
];
const grandParentList = [
  { value: "4", text: "" },
  { value: "0", text: "両親ともに健在" },
  { value: "1", text: "父のみ健在" },
  { value: "2", text: "母のみ健在" },
  { value: "3", text: "両親ともに他界" },
];

class Informations extends React.Component {
  constructor(props) {
    super();
    this.state = {
      artistName: props.book.artistName,
      book: Book.create({})
    };
    this.isChangeChildrenSex = false;
    this.isChangeIsSingle = false;
    this.isChangeGrandParentState = false;
  }

  // onChildrenAge = v => this.state.book.parentToChild.changeChildrenAge(v);
  onChildrenSex = v => {
    this.isChangeChildrenSex = true;
    return this.state.book.parentToChild.changeChildrenSex(v);
  };
  onIsSingle = v => {
    if (v === '1') { // 配偶者の有無 なし
      isSNickNameTooLong = false;
      this.state.book.parentToChild.changeSpouseNickName('');
    }
    this.isChangeIsSingle = true;
    return this.state.book.parentToChild.changeIsSingle(v);
  };
  onGrandParentState = v => {
    this.isChangeGrandParentState = true;
    if (v === '1') { // 父のみ健在
      isGrandMotherNickNameTooLong = false;
      this.state.book.parentToChild.changeGrandMotherNickName('');
    }
    if (v === '2') { // 母のみ健在
      isGrandFatherNickNameTooLong = false;
      this.state.book.parentToChild.changeGrandFatherNickName('');
    }
    if (v === '3') { // 両親ともに他界
      isGrandFatherNickNameTooLong = false;
      this.state.book.parentToChild.changeGrandFatherNickName('');
      isGrandMotherNickNameTooLong = false;
      this.state.book.parentToChild.changeGrandMotherNickName('');
    }
    return this.state.book.parentToChild.changeGrandParentState(v)
  };
  onCNameChange = e => {
    let text = e.target.value;
    text = text.replace(/\u3000/g, " ");
    isCNameTooLong = text.length > CNameLimit;
    this.state.book.parentToChild.changeCreatorName(text);
  };
  onRNameChange = e => {
    let text = e.target.value;
    isRNameTooLong = text.length > RNameLimit;
    this.state.book.parentToChild.changeReceiverName(text);
  };
  onCNickNameChange = e => {
    let text = e.target.value;
    isCNickNameTooLong = text.length > CNickNameLimit;
    this.state.book.parentToChild.changeCreatorNickName(text);
  };
  onSNickNameChange = e => {
    let text = e.target.value;
    isSNickNameTooLong = text.length > SNickNameLimit;
    this.state.book.parentToChild.changeSpouseNickName(text);
  };
  onGrandFatherNickNameChange = e => {
    let text = e.target.value;
    isGrandFatherNickNameTooLong = text.length > GrandFatherNickNameLimit;
    this.state.book.parentToChild.changeGrandFatherNickName(text);
  };
  onGrandMotherNickNameChange = e => {
    let text = e.target.value;
    isGrandMotherNickNameTooLong = text.length > GrandMotherNickNameLimit;
    this.state.book.parentToChild.changeGrandMotherNickName(text);
  };
  onDateChange = date => {
    const today = moment();
    const nextYear = today.add(1, 'year');
    // console.log(date.isAfter(nextYear));
    isOverOneYear = date.isAfter(nextYear.subtract(1, 'days'));
    this.state.book.parentToChild.changeCustomDate(date.toDate());
  };

  updateABook(book, bookFrom) {
    const { parentToChild } = bookFrom;

    // 全角変換
    // parentToChild.changeCreatorName(hankaku2Zenkaku(parentToChild.creatorName));
    parentToChild.changeReceiverName(hankaku2Zenkaku(parentToChild.receiverName));
    parentToChild.changeCreatorNickName(hankaku2Zenkaku(parentToChild.creatorNickName));
    parentToChild.changeSpouseNickName(hankaku2Zenkaku(parentToChild.spouseNickName));
    parentToChild.changeGrandFatherNickName(hankaku2Zenkaku(parentToChild.grandFatherNickName));
    parentToChild.changeGrandMotherNickName(hankaku2Zenkaku(parentToChild.grandMotherNickName));

    book.parentToChild.changeCreatorName(parentToChild.creatorName);
    book.parentToChild.changeReceiverName(parentToChild.receiverName);
    // book.parentToChild.changeChildrenAge(parentToChild.childrenAge);
    book.parentToChild.changeChildrenSex(parentToChild.childrenSex);
    book.parentToChild.changeCreatorNickName(parentToChild.creatorNickName);
    book.parentToChild.changeIsSingle(parentToChild.isSingle);
    book.parentToChild.changeSpouseNickName(parentToChild.spouseNickName);
    book.parentToChild.changeGrandParentState(parentToChild.grandParentState);
    book.parentToChild.changeGrandFatherNickName(parentToChild.grandFatherNickName);
    book.parentToChild.changeGrandMotherNickName(parentToChild.grandMotherNickName);
    book.parentToChild.changeCustomDate(parentToChild.customDate);
  }

  onSave = () => {
    // 子供の性別が変わったか
    if (this.isChangeChildrenSex) {
      this.props.order.changeFacesSaved(false);
    }

    // 配偶者の有無が変わったか
    if (this.isChangeIsSingle) {
      // TODO: 判定は作者に依存している。増えたときに考慮必要かも
      if (this.state.artistName === "nakagawa") {
        this.props.book.parentToChild.exclusionStories(['c', 'd', 'e']);
      } else {
        this.props.book.parentToChild.exclusionStories(['c', 'd']);
      }

      this.props.order.changeStoriesSaved(false);
    }

    // 祖父母の有無が変わったか
    if (this.isChangeGrandParentState) {
      if (this.state.book.parentToChild.grandParentState === "3") {
        this.props.book.parentToChild.exclusionStories(['b']);
      }
      this.props.order.changeStoriesSaved(false);
    }


    this.updateABook(this.props.book, this.state.book);
    // this.setState({ lastSave: Date.now() }); // TODO: 使ってない？
    this.props.order.nextStep();
  };

  componentWillMount() {
    if (this.props.book) {
      this.updateABook(this.state.book, this.props.book);
    }
  }
  render() {
    const book = this.state.book;

    return (
      <div className="informations pd-15">
        <Form layout="vertical">
          <Row>
            <div style={{ padding: "0 0 8px" }}>
              {"あなたのお名前を教えてください。"}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（敬称含め全角10文字以内）"}
              </div>
              <p style={{ fontSize: "10px", color: "#c00" }}>
                {"※姓名の間に必ず半角スペースを入力してください。"}
              </p>
              <p style={{ fontSize: "10px", color: "#c00", marginTop: "-1em" }}>
                {"※作者名として表紙等に印字されます。"}
              </p>
            </div>
            <div data-warning={isCNameTooLong}>
              <Input
                onChange={this.onCNameChange}
                placeholder="例）山田 太郎、山田 花子、パパ、ママ"
                span={24}
                size="large"
                style={{ fontSize: "14px" }}
                value={book.parentToChild.creatorName}
              />
            </div>
          </Row>
          <Row
            data-warning={isRNameTooLong}
            type="flex"
            justify="space-between"
          >
            <div>
              {"プレゼントするお子様のことを普段どのように呼んでいますか？"}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（敬称含め全角6文字以内）"}
              </div>
            </div>
            <Input
              span={24}
              onChange={this.onRNameChange}
              placeholder="例）ハナ、はなちゃん"
              size="large"
              style={{ fontSize: "14px" }}
              value={book.parentToChild.receiverName}
            />
          </Row>
          <Row>
            <div className="label">
              {"お子様の性別を教えてください。"}
            </div>
            <FSelect
              defaultValue={`${book.parentToChild.childrenSex}`}
              onChange={this.onChildrenSex}
              size="large"
            >
              {childrenAgeSexList.map(item => (
                <Option key={item.value} value={item.value}>{item.text}</Option>
              ))}
            </FSelect>
          </Row>
          <Row
            data-warning={isCNickNameTooLong}
            type="flex"
            justify="space-between"
          >
            <div>
              {"あなたはお子様から普段どのように呼ばれていますか？"}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（敬称含め全角6文字以内）"}
              </div>
            </div>
            <Input
              span={24}
              onChange={this.onCNickNameChange}
              placeholder="例）パパ、ママ、おとうさん、おかあさん"
              size="large"
              style={{ fontSize: "14px" }}
              value={book.parentToChild.creatorNickName}
            />
          </Row>
          <Row>
            <div className="label">
              {"配偶者(夫/妻)の有無をおしえてください。"}
            </div>
            <FSelect
              defaultValue={book.parentToChild.isSingle}
              onChange={this.onIsSingle}
              size="large"
            >
              {singleStateList.map((item, index) => (
                <Option key={index} value={item.value}>{item.text}</Option>
              ))}
            </FSelect>
          </Row>
          { !(book.parentToChild.isSingle === "1") &&
            <Row
              data-warning={isSNickNameTooLong}
              type="flex"
              justify="space-between"
            >
              <div>
                {"お子様は、あなたの配偶者のことをどのように呼んでいますか？"}
                <br />
                <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                  {"（敬称含め全角6文字以内）"}
                </div>
              </div>
              <Input
                span={24}
                onChange={this.onSNickNameChange}
                placeholder="例）パパ、ママ、おとうさん、おかあさん"
                size="large"
                style={{ fontSize: "14px" }}
                value={book.parentToChild.spouseNickName}
              />
            </Row>
          }
          <Row>
            <div className="label">
              {"あなたのご両親(お子様の祖父母様)についておしえてください。"}
            </div>
            <FSelect
              defaultValue={book.parentToChild.grandParentState}
              onChange={this.onGrandParentState}
              size="large"
            >
              {grandParentList.map((item, index) => (
                <Option key={index} value={item.value}>{item.text}</Option>
              ))}
            </FSelect>
          </Row>
          { (
              book.parentToChild.grandParentState === "0" ||
              book.parentToChild.grandParentState === "1"
            ) &&
            <Row
              data-warning={isGrandFatherNickNameTooLong}
              type="flex"
              justify="space-between"
            >
              <div>
                {"お子様はご祖父様のことを普段どのように呼んでいますか？"}
                <br />
                <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                  {"（敬称含め全角6文字以内）"}
                </div>
              </div>
              <Input
                span={24}
                onChange={this.onGrandFatherNickNameChange}
                placeholder="例）じいじ、おじいちゃん"
                size="large"
                style={{ fontSize: "14px" }}
                value={book.parentToChild.grandFatherNickName}
              />
            </Row>
          }
          { (
            book.parentToChild.grandParentState === "0" ||
            book.parentToChild.grandParentState === "2"
          ) &&
            <Row
              data-warning={isGrandMotherNickNameTooLong}
              type="flex"
              justify="space-between"
            >
              <div>
                {"お子様はご祖母様のことを普段どのように呼んでいますか？"}
                <br />
                <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                  {"（敬称含め全角6文字以内）"}
                </div>
              </div>
              <Input
                span={24}
                onChange={this.onGrandMotherNickNameChange}
                placeholder="例）ばあば、おばあちゃん"
                size="large"
                style={{ fontSize: "14px" }}
                value={book.parentToChild.grandMotherNickName}
              />
            </Row>
          }
          <Row>
            <div>
              {(() => {
                const urlParams = new URLSearchParams(window.location.search);
                const hasKey = urlParams.has('key');
                return hasKey
                  ? "シカケテガミへの刻印日（挙式日など）をお選びください。"
                  : "シカケテガミに刻印する記念日をお選びください。";
              })()}
              <br />
              <div style={{ fontSize: "11px", padding: "0 0 8px" }}>
                {"（本の最終ページに印字されます）"}
              </div>
              <p style={{ fontSize: "11px", padding: "0 0 8px", color: "#c00" }}>
                {"※ 商品のお届け日をお約束するものではございません。"}
              </p>
            </div>
            <div
              className="c-calenderConfirm"
              data-over={isOverOneYear ? 'true' : 'false'}
            >
              <div className="c-calenderConfirm__comment"><span></span></div>
              <DatePicker
                allowClear={false}
                locale={locale}
                disabledDate={m => m.valueOf() <= moment().subtract(90, 'day').valueOf()}
                onChange={this.onDateChange}
                size="large"
                style={{ fontSize: "14px" }}
                value={moment(book.parentToChild.customDate)}
              />
            </div>
          </Row>
          <ChildrenTemplaceRender book={book} />
          <div className="btn-wrap" style={{ marginTop: "24px" }}>
            <button
              className="btn product-btn"
              disabled={!book.parentToChild.isInfoSet ||
                isCNameTooLong ||
                isRNameTooLong ||
                isCNickNameTooLong ||
                isSNickNameTooLong ||
                isGrandFatherNickNameTooLong ||
                isGrandMotherNickNameTooLong
              }
              onClick={this.onSave}
            >
              保存して次へ
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default observer(Informations);



// WEBPACK FOOTER //
// ./src/components/steps/InformationsParentToChild.js